/**
 * @file   src\services\signupService.js
 * @brief  This file is responsible for sign up services
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import * as endPoints from "../../constants/v2/endPoints";
import * as apiService from "../v2/apiService";

export async function verifyEmail(email) {
  return await apiService.apiCallWithoutToken(
    endPoints.VERIFY_EMAIL_V2,
    "POST",
    email,
  );
}

export async function signup(userInfo) {
  return await apiService.apiCall(endPoints.SIGNUP, "POST", userInfo);
}

export async function resendEmail(userInfo) {
  return await apiService.apiCall(endPoints.RESEND_EMAIL_V2, "POST", userInfo);
}

export async function saveAgentInfo(agentInfo) {
  return await apiService.apiCall(
    endPoints.SAVE_AGENT_INFO_V2,
    "POST",
    agentInfo,
  );
}

export async function saveAgentPicture(agentInfo) {
  const { userId, width, height, profileImage } = agentInfo;
  const isUpload = true;
  return await apiService.apiCall(
    endPoints.SAVE_AGENT_PICTURE +
      `?width=${width}&height=${height}&profileImage=${profileImage}
  `,
    "POST",
    {},
    "",
    "",
    isUpload,
  );
}

export async function userSignUp(reqPayload) {
  return await apiService.apiCallWithoutToken(
    endPoints.USER_SIGN_UP_V2,
    "POST",
    reqPayload,
  );
}
export async function userLogin(reqPayload) {
  return await apiService.apiCallWithoutToken(
    endPoints.USER_LOGIN_V2,
    "POST",
    reqPayload,
  );
}

export async function userEmailVerification(reqPayload) {
  return await apiService.apiCallWithoutToken(
    endPoints.VERIFY_USER_EMAIL_V2,
    "POST",
    reqPayload,
  );
}

export async function saveUserType_Title(reqPayload) {
  return await apiService.apiCall(
    endPoints.SAVE_USERTYPE_AND_TITLE_API_V2,
    "POST",
    reqPayload,
  );
}
